import PropTypes from 'prop-types';

import GatedContent from './GatedContent';

import Dialog from '@mui/material/Dialog';

function GatedDialog(props) {
  const { onClose, open, ...rest } = props;
  return (
    <Dialog onClose={onClose} open={open} slotProps={{ paper: { sx: { py: [4, 6], px: [4, 10] } } }}>
      <GatedContent {...rest} onActionClicked={onClose} />
    </Dialog>
  );
}

GatedDialog.propTypes = {
  courseSubscription: PropTypes.object,
  eventTrackingProperties: PropTypes.object.isRequired,
  onlineCourse: PropTypes.object.isRequired,
  onlineCourseUser: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onPurchase: PropTypes.func.isRequired,
  // onStartTrial: PropTypes.func.isRequired,
  onTokenPurchase: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  subscription: PropTypes.object,
  tokenPrice: PropTypes.number,
  tokenPurchaseStatus: PropTypes.object,
  userCourse: PropTypes.object,
};

export default GatedDialog;
